import styled from 'styled-components';
import Icon from '../../assets/images/edit-icon.svg';

const EditIcon = styled.span`
  background: url(\"${Icon}\") no-repeat left center;
  background-size: 25px 28px;
  display: block;
  position: relative;
  width: 25px;
  height: 28px;
`;

export default EditIcon;
